import {
  put, takeLatest, all, call,
} from 'redux-saga/effects';

import { startLoading } from 'domain/layout/actions';
import { DEFAULT_LOCATION } from 'constants';
import { fetchCurrentLocation, fetchedCurrentLocation } from './actions';
import * as API from './api';

function* doFetchUserLocation() {
  try {
    yield put(fetchCurrentLocation());
    const { coords, country } = yield call(API.getUserLocation);
    const payload = {
      lat: coords.latitude || DEFAULT_LOCATION.lat,
      lng: coords.longitude || DEFAULT_LOCATION.lng,
    };
    if (country) {
      payload.country = [country];
    } else {
      payload.country = [DEFAULT_LOCATION.country];
    }
    yield put(fetchedCurrentLocation(payload));
  } catch (e) {
    yield put(
      fetchedCurrentLocation({
        lat: DEFAULT_LOCATION.lat,
        lng: DEFAULT_LOCATION.lng,
        country: [DEFAULT_LOCATION.country],
      }),
    );
    console.error(e);
  }
}

function* watcher() {
  yield all([takeLatest(startLoading().type, doFetchUserLocation)]);
}

export default watcher;
